import { clearSession, http } from '@/lib/apiClient';

export interface AuthUser {
  id: string;
  username: string;
  email: string;
  fullName: string;
  userType: 'INTERNAL' | 'VENDOR';
  vendorId: string | null;
  roles: string[];
  permissions: string[];
}

export interface AuthSession {
  accessToken: string;
  refreshToken: string;
  tokenType: string;
  expiresAt: string;
  user: AuthUser;
}

export const authApi = {
  login: (body: { usernameOrEmail: string; password: string }) => http.post<AuthSession>('/api/v1/auth/login', body),
  me: () => http.get<AuthUser>('/api/v1/auth/me'),
  changePassword: (body: { currentPassword: string; newPassword: string }) => http.post<void>('/api/v1/auth/change-password', body),
  logout: async () => {
    const refreshToken = localStorage.getItem('vendiz.refreshToken');
    try { await http.post<void>('/api/v1/auth/logout', undefined, refreshToken ? { 'X-Refresh-Token': refreshToken } : undefined); }
    finally { clearSession(); }
  },
};
